var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wework-app-box"},[(_vm.hasGetData)?_c('div',{staticClass:"wework-app-tit"},[_vm._v(" 请使用已绑定的企业微信 "),_c('b',[_vm._v(_vm._s(_vm.accountInfo.corp_name))]),_vm._v(" 来安装以下应用 ")]):_vm._e(),_c('app-install-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }